import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle } from 'app/utils/web-helpers';
import { useEffect, type ComponentProps, type FC } from 'react';
import { useLandingPageSetup } from './use-landing-page-setup';
import { LandingPageContent } from './landing-page-content.large';

type LandingPageScreenComponentProps = ComponentProps<NavigationScreen<'landing-page'>> & { isDesktop: boolean };

export const LandingPageScreenComponent: FC<LandingPageScreenComponentProps> = ({ navigation }) => {
  useLandingPageSetup({ navigation });

  const setPageTitle = usePageTitle('billboard');
  useEffect(() => setPageTitle('tabBarLabel'), [setPageTitle]);

  return <LandingPageContent />;
};
